// graphql.ts
import { useLazyQuery } from '@apollo/client';
import gql from 'graphql-tag';

const gqlGetSeries = gql`
  query getCollectionLinesView($where: String, $offset: Int, $limit: Int, $order: String) {
    getCollectionLinesView(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: code
        description: seriesName
      }
      recordCount
    }
  }
`;

export const gqlGetQuery = gql`
  query getCollectionLinesView($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectionLinesView(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        qty
        containersQty
        netWeight
        jobtypeName
        materialName
        containertypeName
        code
        seriesId
        finDispNote
        dateCollected
        dateStorage
        colpointContactPerson
        seriesName
        vehiclePlateNumber
        driverName
        collectorName
        wastereceptionpointName
        wastereceptionpointTypeName
        wastereceptionpointRegionName
        collectionpointName
        colpointCategoryName
        colpointGroupName
        colpointSubGroupName
        colpointSubSubGroupName
        colpointProfessionName
        colpointRegionName
        colpointSubRegionName
      }
      recordCount
    }
  }
`;
// export const gqlGetQuery = gql`
//   query getCollections($limit: Int, $offset: Int, $order: String, $where: String) {
//     getCollections(limit: $limit, offset: $offset, order: $order, where: $where) {
//       data {
//         id
//         code
//         seriesId
//         codePrefix
//         codeNumber
//         dateCollected
//         collectionPointId
//         collectorId
//         wastereceptionpointId
//         legacyAppId
//         recordDate
//         isActive
//         firstDate
//         lastDate
//         finDispNote
//         firstUser
//         lastUser
//         collectionpoint {
//           id
//           name
//           addressLine1
//           addressLine2
//           addressArea
//           addressCity
//           addressDistrict
//           postalCode
//           phone
//           regionId
//           region {
//             id
//             name
//           }
//         }
//         collector {
//           id
//           name
//         }
//         wastereceptionpoint {
//           id
//           name
//         }
//         collectionLines {
//           id
//           aa
//           materialId
//           finDispNote
//           qty
//           netWeight
//           material {
//             id
//             name
//           }
//         }
//         idocs {
//           id
//           identificationDocument
//         }
//       }
//       recordCount
//     }
//   }
// `;
